var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.iconUrl)?_c('img',{staticClass:"icon",attrs:{"src":_vm.iconUrl}}):_vm._e(),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.heroList),expression:"heroList"}],attrs:{"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }